import { useEffect, useState } from "react";
import { Trash2, Mail, Phone } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function AdminContacts() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/contacts").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const del = async (id) => { if (window.confirm("Supprimer ?")) { await api.delete(`/contacts/${id}`); load(); } };
  const setStatus = async (id, status) => { await api.patch(`/contacts/${id}`, { status }); toast.success("Mis à jour"); load(); };

  return (
    <div data-testid="admin-contacts">
      <h1 className="font-display text-4xl tracking-tight font-light text-white mb-8">Demandes</h1>

      <div className="space-y-4">
        {items.map((c) => (
          <div key={c.id} className="bg-[#1E1E1E] border border-white/10 rounded-md p-6">
            <div className="flex items-start justify-between gap-4 mb-4 flex-wrap">
              <div>
                <p className="text-white font-medium text-lg">{c.name}</p>
                <div className="flex flex-wrap gap-4 text-sm text-white/60 mt-1">
                  <a href={`mailto:${c.email}`} className="hover:text-[#C8A75A] flex items-center gap-1"><Mail className="w-3.5 h-3.5" />{c.email}</a>
                  {c.phone && <a href={`tel:${c.phone}`} className="hover:text-[#C8A75A] flex items-center gap-1"><Phone className="w-3.5 h-3.5" />{c.phone}</a>}
                </div>
              </div>
              <div className="flex items-center gap-3">
                <select value={c.status} onChange={(e) => setStatus(c.id, e.target.value)} className="bg-black border border-white/10 text-white text-xs px-3 py-2 rounded-md">
                  <option value="new">Nouveau</option>
                  <option value="in_progress">En cours</option>
                  <option value="closed">Clôturé</option>
                </select>
                <button onClick={() => del(c.id)} className="text-white/60 hover:text-red-400 p-2"><Trash2 className="w-4 h-4" /></button>
              </div>
            </div>
            <div className="flex flex-wrap gap-3 text-xs mb-3">
              <span className="text-[#C8A75A] uppercase tracking-widest">{c.request_type}</span>
              {c.subject && <span className="text-white/50">· {c.subject}</span>}
              <span className="text-white/40 ml-auto">{new Date(c.created_at).toLocaleString("fr-BE")}</span>
            </div>
            <p className="text-white/80 whitespace-pre-line text-sm bg-black/30 p-4 rounded-md border-l-2 border-[#C8A75A]/60">{c.message}</p>
          </div>
        ))}
        {items.length === 0 && <p className="text-white/40 text-center py-16">Aucune demande.</p>}
      </div>
    </div>
  );
}
